<template>
<modal title="Edit Secure Setting">
  
  <div class="columns">
    <div class="column">
      <p class="has-text-weight-bold has-text-primary">
        {{ checkpoint.assessor.type.name }}
      </p>
      <p>
        {{ checkpoint.assessor.type.description }}
      </p>
    </div>
  </div>
  <div class="columns">
    <div class="column">
      <text-area 
        v-model="setting.secure_setting"
        :error="$root.errorBag.secure_setting">Secure Setting Value</text-area>
    </div>
  </div>

  <template #footer>
    <div class="buttons">
      <action-button :working="saving" @click="saveSecureSetting">Save</action-button>
    </div>
  </template>
</modal>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  
  props: {
    section: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    saving: false,
    setting: {
      secure_setting: ''
    }
  }),

  created() {
    this.setting.secure_setting = this.section.setting.secure_setting
  },

  methods: {
    saveSecureSetting() {
      this.working = true
      this.$store.dispatch('checkpoint/updateStandardSecureSetting', {
        ...this.setting,
        sectionId: this.section.id,
        checkpointId: this.checkpoint.id
      }).then(() => {
        this.working = false
        this.$close(true)
      }).catch(error => {
        this.working = false
      })
    }
  },

  computed: {
    ...mapGetters('checkpoint', [
      'checkpoint'
    ])
  },

}
</script>